var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80",
    height: "80",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: "40",
    cy: "40",
    r: "40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.97 42.1H41.5v12.52s5.29.2 9.2-4.32c3.9-4.52 3.28-8.2 3.28-8.2z",
    fill: "#F22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.09 56.59a16.09 16.09 0 1 1 0-32.18 16.09 16.09 0 0 1 0 32.18zm0-3.22a12.87 12.87 0 1 0 0-25.74 12.87 12.87 0 0 0 0 25.74z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0097DC",
    d: "M40.28 22h2.41v9.65h-2.41zM62 39.7v2.4h-9.65v-2.4zM53.55 26.02l1.7 1.7-6.82 6.83-1.7-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.19 37.03l-.03-.03.3-.16c.22-.14.45-.26.68-.35l11.72-6.06-6.06 11.7c-.1.25-.22.48-.36.7l-.15.3-.03-.03c-.13.16-.26.32-.41.47a4.34 4.34 0 1 1-5.66-6.54z",
    fill: "#0097DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.36 37.93l-.02-.02.2-.1c.14-.1.29-.17.44-.23l7.6-3.94-3.93 7.6c-.06.16-.14.31-.23.45l-.1.2-.02-.02-.26.3a2.82 2.82 0 1 1-3.68-4.24z",
    fill: "#FFF"
  })));
});